import { AxiosInstance } from 'axios';
import { BankIntegrationVendor } from './bank-integration-vendor';

export type Language = 'en' | 'de';

export interface BankAppConfiguration extends OptionalConfiguration {
	shortTermToken: string;
	longTermToken: string;
	inviteToken: string;
	url: string;
	callbacks?: Callbacks;
	bankIntegrationVendor?: BankIntegrationVendor;
	setupApiClient?: (axiosInstance: AxiosInstance) => (() => void) | void;
}

export interface OptionalConfiguration {
	bankRedirectMethod?: PSD2RedirectMethod;
	language?: Language;
	primaryColor?: string;
	secondaryColor?: string;
	autoClose?: boolean;
	autoCloseSeconds?: number;
	reuseSession?: boolean;
}

export interface Callbacks {
	onLoad?(): void;
	onReady?(): void;
	onFinished?(): void;
	onAbort?(): void;
	onError?(): void;
	onClose?(): void;
}

export type PSD2RedirectMethod = 'newWindow' | 'sameWindow';

export type CallbackEvent = keyof Callbacks;

export const CALLBACK_EVENTS = ['onLoad', 'onReady', 'onAbort', 'onError', 'onFinished', 'onClose'];
